import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 11 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M.333 10.936c-.497.218-.42.946.112 1.054l3.791.77.774 3.795c.109.532.836.609 1.054.112L9.952 7.78a.555.555 0 0 0-.732-.732L.333 10.936zm5.417 3.688l-.5-2.45a.555.555 0 0 0-.433-.433l-2.423-.494L8.37 8.633l-2.619 5.99z" transform="translate(0 -6)" fill={color} fillRule="evenodd"/>
    </svg>
)

export default class IconLocation extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
